/**
 * Sets data-strl-label-ink from data-strl-label-surface hex on .inspiration-card-media-frame.
 */

function getContrastColor(hexColor) {
	let hex = String(hexColor).trim();
	if (hex.charAt(0) === '#') {
		hex = hex.slice(1);
	}
	if (hex.length === 3) {
		hex = hex
			.split('')
			.map(function (c) {
				return c + c;
			})
			.join('');
	}
	if (hex.length !== 6) {
		return 'black';
	}
	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
	if (luminance > 0.5) {
		return 'black';
	}
	return 'white';
}

function applyInspirationCardLabelInk() {
	const frames = document.querySelectorAll('.inspiration-card-media-frame[data-strl-label-surface]');
	for (let i = 0; i < frames.length; i += 1) {
		const frame = frames[i];
		const hex = frame.getAttribute('data-strl-label-surface');
		const label = frame.querySelector('.inspiration-card-type-label');
		if (!hex || !label) {
			continue;
		}
		label.setAttribute('data-strl-label-ink', getContrastColor(hex));
	}
}

function boot() {
	applyInspirationCardLabelInk();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}

document.addEventListener('facetwp-loaded', boot);
